module.exports = __webpack_public_path__ + "img/GOPAY.2e35067a.png";